export default "__VITE_ASSET__B2Jt5NB3__"